import { useEffect, useMemo } from "react";
import { Card, Space } from "antd";
import PvTable from "../../components/Table/PvTable";
import ViewingFormButton from "../../components/Form/ViewingFormButton";
import useFsrAdminService from "../../services/FsrAdmin/fsrAdminService";
import { formatIsoDate, renderStatus } from "../../utils/generalUtils";
import { mapUnitToAcronym } from "../../utils/ouberUtils";

const FACULTY_OPTIONS = [
  { label: "FEd", value: "Faculty of Education" },
  { label: "FICS", value: "Faculty of Information and Communication Studies" },
  { label: "FMDS", value: "Faculty of Management and Development Studies" },
];

const OTHER_FACULTY_VALUE = "__OTHERS__";

const AllFsrSection = () => {
  const { getAllFsr, allFsrLoading, allFsrResponse } = useFsrAdminService();

  useEffect(() => {
    getAllFsr();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tableData = useMemo(
    () =>
      (allFsrResponse?.data || []).map((item, index) => {
        const submitter = item?.submission?.submitter;
        return {
          key: index + 1,
          id: item?.id,
          submission_id: item?.submission?.id,
          employee_name: submitter
            ? [submitter.first_name, submitter.middle_name, submitter.last_name]
                .filter(Boolean)
                .join(" ")
            : "—",
          faculty: item?.faculty,
          academic_term: item?.academic_term,
          status: item?.submission?.derived_status || item?.submission?.status,
          created_at: item?.created_at,
        };
      }),
    [allFsrResponse]
  );

  const columns = [
    { title: "No.", dataIndex: "key", key: "key", width: 60 },
    { title: "Employee", dataIndex: "employee_name", key: "employee_name" },
    {
      title: "Faculty",
      dataIndex: "faculty",
      key: "faculty",
      render: (value) => mapUnitToAcronym(value) || value,
      filters: [
        ...FACULTY_OPTIONS.map((option) => ({
          text: option.label,
          value: option.value,
        })),
        { text: "Others", value: OTHER_FACULTY_VALUE },
      ],
      defaultFilteredValue: FACULTY_OPTIONS.map((option) => option.value),
      onFilter: (value, record) =>
        value === OTHER_FACULTY_VALUE
          ? !FACULTY_OPTIONS.some((option) => option.value === record.faculty)
          : record.faculty === value,
    },
    {
      title: "Academic Term",
      dataIndex: "academic_term",
      key: "academic_term",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: renderStatus(
        ["pending", "pending - chairs", "pending - dean"],
        ["approved"],
        ["disapproved", "denied"]
      ),
    },
    {
      title: "Date Submitted",
      dataIndex: "created_at",
      key: "created_at",
      render: (value) => formatIsoDate(value),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <ViewingFormButton
          contents={record}
          viewingType="pdf"
          viewingPdfEndpoint="/fsr/pdf/snapshot"
          viewingModalWidth={1000}
          isIcon
        />
      ),
    },
  ];

  return (
    <Card title="All Faculty Service Records">
      <Space direction="vertical" style={{ width: "100%" }}>
        <PvTable
          data={tableData}
          columns={columns}
          loading={allFsrLoading}
          onRowClick={() => {}}
        />
      </Space>
    </Card>
  );
};

export default AllFsrSection;
